import {OcListElementType, OcListMapType, OcListViewInfoElementType, OcSearchParamType} from "../interface";

export const ocSearchParamType: OcSearchParamType = {
    limit: 10,
    pageNo: 1,
    keywordType: "0",
    region: "SEA",
    month: "",
    year: "",
    exchangeRate: "0",
    startAt: "",
    endAt: "",
    exchangeFlag: 1
}

export const ocListViewInfoVOLIstElementInit: OcListViewInfoElementType = {
    overseasViewInfoId: 0,
    target: "",
    isHidden: "N",
};

export const ocSearchOverseasResListElementInit: OcListElementType = {
    overseasId: 0,
    year: "",
    salesOutDate: "",
    region: "",
    country: "",
    customer: "",
    application: "",
    product: "",
    productName: "",
    msProductCode: "",
    unitPriceUsd: 0,
    unitPriceInr: 0,
    salesRevenueUsd: 0,
    salesRevenueInr: 0,
    exchangeRate: 0,
    salesRevenueWon: 0,
    remark: "",
    projectInformation: "",
    invoicedDate: "",
    quantity: 0,
};

export const ocListMapInit: OcListMapType = {
    overseasViewInfoVOList: [],
    overseasVOList: [],
    totalCount: 0,
};